<script setup>
defineProps({
    section: Object,
    currentSection: Object,
    count: {
        type: Number,
        default: 0,
    },
    tool: String,
});

const emit = defineEmits(["open"]);

const openSection = (section) => {
    emit("open", section);
};
</script>

<template>
    <div
        class="cursor-pointer ring-1 ring-inset ct-ring-1 hover:ct-ring-brand ct-bg-1--alt rounded-lg p-2 flex items-center space-x-2 shadow-sm shadow-gray-900/5 h-12"
        :class="{
            'ct-ring-brand ct-ring-focus': currentSection && currentSection.title === section.title,
        }"
        @click="openSection(section)"
    >
        <div class="flex items-center justify-between w-full">
            <div class="flex items-center gap-3">
                <div
                    class="w-8 h-8 rounded-lg flex items-center justify-center"
                    :class="{
                        [`bg-${tool}-500`]: !!tool,
                        'bg-opacity-10': !!tool,
                        'ct-bg-3': !tool,
                        'text-gray-500 dark:text-neutral-200': !tool,
                    }"
                >
                    <component :is="section.icon" :class="tool ? `text-${tool}-500` : 'h-4 w-4'" />
                </div>
                <span class="text-sm">{{ section.title }}</span>
            </div>
            <div v-if="!tool" class="text-xs ct-fg-3">{{ section.count }} types</div>
        </div>
    </div>
</template>
